import { render, staticRenderFns } from "./VendorCtField.vue?vue&type=template&id=5144d137"
import script from "./VendorCtField.vue?vue&type=script&lang=js"
export * from "./VendorCtField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports